/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProposalSummaryPhaseInCollectiveInvestments
 */
export interface ProposalSummaryPhaseInCollectiveInvestments {
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryPhaseInCollectiveInvestments
     */
    assetCode?: number;
    /**
     * 
     * @type {string}
     * @memberof ProposalSummaryPhaseInCollectiveInvestments
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryPhaseInCollectiveInvestments
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryPhaseInCollectiveInvestments
     */
    percentage?: number;
}

/**
 * Check if a given object implements the ProposalSummaryPhaseInCollectiveInvestments interface.
 */
export function instanceOfProposalSummaryPhaseInCollectiveInvestments(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProposalSummaryPhaseInCollectiveInvestmentsFromJSON(json: any): ProposalSummaryPhaseInCollectiveInvestments {
    return ProposalSummaryPhaseInCollectiveInvestmentsFromJSONTyped(json, false);
}

export function ProposalSummaryPhaseInCollectiveInvestmentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalSummaryPhaseInCollectiveInvestments {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assetCode': !exists(json, 'AssetCode') ? undefined : json['AssetCode'],
        'name': !exists(json, 'Name') ? undefined : json['Name'],
        'amount': !exists(json, 'Amount') ? undefined : json['Amount'],
        'percentage': !exists(json, 'Percentage') ? undefined : json['Percentage'],
    };
}

export function ProposalSummaryPhaseInCollectiveInvestmentsToJSON(value?: ProposalSummaryPhaseInCollectiveInvestments | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'AssetCode': value.assetCode,
        'Name': value.name,
        'Amount': value.amount,
        'Percentage': value.percentage,
    };
}

